// extracted by mini-css-extract-plugin
export default {"title":"offer_title__-gNLg","text":"offer_text__q7PKc","mr100":"offer_mr100__L4rK2","mr50":"offer_mr50__ShGni","signature":"offer_signature__-AI4i"};